/**
 * @module CityPicker
 * @author Created by yanghongmei1
 */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { View, StyleSheet } from 'react-native';

import CityItem from './cityItem';
import ProvinceItem from './provinceItem';
import { JDScrollView } from '@jdreact/jdreact-core-lib';

import { pt } from '../../../../components/utiles';
const l3All = [{name: '全部', tradingAreaId: 0}]
const formatStr = (str)=> {
    if (str) {
        return str.split(',')
    } else {
        return []
    }
}
const formatNowIndex = (obj)=> {
    if (obj.nearId) {
        return 2
    } else {
        return 1
    }
}
export default class CityPicker extends PureComponent {
    static defaultProps = {
        name: 'CityPicker',
        customStyle: {},
        maxLevel: 3,
        cityData: [],
        NearList: [],
        isMultiSelect: true,
        fristCode: 1,
        searchObj: {},
        showNear: false,
        talkParams: () => {} // 第一个参数是选择的list,第二个参数是传递过来的tabIndex(当前组件在大搜索中的index)没有就不回传
    }

    constructor(props) {
        super(props);
        
        this.state = {
            nowPageIndex: formatNowIndex(this.props.searchObj),
            mySearchObj: this.props.searchObj,
            mySelect_List3_id: [],
            l3List: []
            // l3List: this.props.cityData.find(l1 => l1.thirdCode === this.props.searchObj.countyId)? l3All.concat(l1.childList) : []
        };
    }

    componentDidMount() {
        const {searchObj, cityData} = this.props
        const { streetIds, countyId } = searchObj|| {}
        if (countyId && cityData.length > 0) {
            let list3 = []
            for (let j = 0; j < cityData.length; j++) {
                if(cityData[j] && countyId == cityData[j].thirdCode){
                    list3 = l3All.concat(cityData[j].childList ? cityData[j].childList : [])
                }
            }
            this.setState({
                l3List:list3,
                mySelect_List3_id:formatStr(streetIds)
            })
        }

    }
    _resetClick = () => {
        this.setState({
            mySearchObj: {
                countyId: '',
                streetIds: '',
                nearId: ''
            },
            mySelect_List3_id: [],
            l3List: []
        });
    }

    _AllOkClick = () => {
        const { mySearchObj } = this.state;
        this.props.talkParams(mySearchObj);
    }

    handleSelectCity = (item) => {
        try {
            const { cityData } = this.props
            const { mySearchObj, mySelect_List3_id } = this.state
            if (item.tradingAreaId === 0) { // 点击全部
                this.setState({
                    mySearchObj: {...mySearchObj, streetIds:''},
                    mySelect_List3_id: [],
                })
            } else { // 多选时点击其他
                if (mySelect_List3_id.includes(item.tradingAreaId+'')) {
                    const existIndex = mySelect_List3_id.findIndex(_ => _ == item.tradingAreaId);
                    mySelect_List3_id.splice(existIndex, 1);
                } else {
                    mySelect_List3_id.push(item.tradingAreaId + '')
                }
                this.setState({
                    mySearchObj: {...mySearchObj, streetIds:mySelect_List3_id.join()},
                    mySelect_List3_id: mySelect_List3_id,
                })
            }
        } catch (err) {

        }
    }

    secondClick = (item,index) => {
        const { cityData } = this.props
        const { mySearchObj } = this.state
        if (item.thirdCode) {
            if (mySearchObj.countyId == item.thirdCode) {
                return false
            }
            const nowList = cityData[index].childList ? cityData[index].childList : []
            const l3List = l3All.concat(nowList)
            this.setState({
                mySearchObj: {countyId: item.thirdCode + '', streetIds:'', nearId: ''},
                mySelect_List3_id: [],
                l3List: l3List
            })
        } else {
            this.setState({
                mySearchObj: {countyId: '', streetIds:'', nearId: ''},
                mySelect_List3_id: [],
                l3List: []
            })
        }
    };
    FristClick = (item) => {
        const {nowPageIndex} = this.state
        if (nowPageIndex === item.id) return
        this.setState({
            nowPageIndex: item.id,
        },()=>{this._resetClick()})
    };
    nearClick= (item) => {
        this.setState({
            mySearchObj: {
                countyId: '',
                streetIds:'',
                nearId: item.id ? item.id : ''
            },
            mySelect_List3_id: []
        })
    };

    render() {
        const {
            maxLevel,
            cityData,
            isMultiSelect,
            NearList,
            showNear
        } = this.props;
        // 是否展示级联选择
        
        const { nowPageIndex, mySearchObj, l3List, mySelect_List3_id } = this.state;
        const l1List = showNear ? [{name:'区域',id: 1},{name:'附近',id: 2}] : [{name:'区域',id: 1}]
        const l2List = cityData; 
        return (
            <View style={styles.container}>
                <View style={styles.cityPickerContainer}>
                    <View style={styles.container_com}>
                        {maxLevel > 1 && <View style={styles.level1Container}>
                            <JDScrollView>
                                {l1List.map((item, index) => {
                                    return (
                                        <ProvinceItem
                                            title={item.name}
                                            key={index+'_l1List'}
                                            isSelected={nowPageIndex === item.id}
                                            onSelect={() => {this.FristClick(item)}}
                                        />
                                    );
                                })}
                            </JDScrollView>
                        </View>}
                        {nowPageIndex === 1 && <View style={styles.cascadeContainer}>
                            <View style={styles.level2Container}>
                                <JDScrollView>
                                    {l2List.length > 0 && l2List.map((item, index) => {
                                        return (
                                            <CityItem
                                                title={item.thirdName}
                                                key={index+'_l2List'}
                                                isSelected={mySearchObj.countyId == item.thirdCode || (!mySearchObj.countyId && item.thirdCode === 0)}
                                                isMultiSelect={false}
                                                onSelect={() => {
                                                    this.secondClick(item, index);
                                                }}
                                            />
                                        );
                                    })}
                                </JDScrollView>
                            </View>
                            {l3List.length > 0 && <View style={styles.level3Container}>
                                <JDScrollView>
                                    {l3List.map((item, index) => {
                                        return (
                                            <CityItem
                                                title={item.name}
                                                key={index+'_l3List'}
                                                isSelected={mySelect_List3_id.includes(item.tradingAreaId + '') || (!mySearchObj.streetIds && item.tradingAreaId == 0)}
                                                isMultiSelect={isMultiSelect && item.tradingAreaId !== 0}
                                                onSelect={() => {
                                                    this.handleSelectCity(item);
                                                }}
                                            />
                                        );
                                    })}
                                </JDScrollView>
                            </View>}
                        </View>}
                        {nowPageIndex === 2 && showNear && <View style={styles.recommendWrapper}>
                            <View style={styles.level3Container}>
                                    <JDScrollView>
                                        {NearList.length > 0 && NearList.map((item, index) => {
                                            return (
                                                <CityItem
                                                    title={item.name}
                                                    key={index+'_nearList'}
                                                    isSelected={mySearchObj.nearId == item.id || (!mySearchObj.nearId && item.id === 0)}
                                                    isMultiSelect={false}
                                                    onSelect={() => {
                                                        this.nearClick(item);
                                                    }}
                                                />
                                            );
                                        })}
                                    </JDScrollView>
                                </View>
                        </View>}
                    </View>
                </View>
            </View>
        );
    }
}

CityPicker.propTypes = {
    name: PropTypes.string,
    title: PropTypes.string,
    list: PropTypes.array,
    searchObj: PropTypes.object,
    customStyle: PropTypes.any,
    talkParams: PropTypes.func
};

const styles = StyleSheet.create({
    container: {
        display: 'flex',
        flexDirection: 'column',
        flex: 1
    },
    cityPickerContainer: {
        width: '100%',
        height: '100%',
        backgroundColor: '#fff'
    },
    container_com: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'flex-start',
        flex: 1
    },
    level1Container: {
        flexDirection: 'column',
        width: pt(170),
        backgroundColor: '#F6F6F6',
        height: '100%'
    },
    level2Container: {
        width: '50%',
        flexDirection: 'column',
        height: '100%',
        backgroundColor: '#fff',
        borderRightColor: '#eee',
        borderRightWidth: pt(1)
    },
    level3Container: {
        flex: 1,
        flexDirection: 'column',
        height: '100%',
        backgroundColor: '#fff',
    },
    cascadeContainer: {
        height: '100%',
        flexDirection: 'row',
        flex: 1
    },
    recommendWrapper: {
        height: '100%',
        flex: 1
    }
});
